<template>
  <div>
    <TopNav />
    <div class="dateForm" v-show="showDate">
      <p @click="showDateOff" class="exit">x</p>
      <p>Enter Date <small>(dd-mm-yyyy)</small></p>
      <input class="date" type="date" v-model="date" />
      <button @click="setDate" class="setDate">set</button>
    </div>
    <div class="toolbar">
      <button v-if="currentBufferGraphic" @click="clearBuffer">
        Clear Radius
      </button>
    </div>
    <div v-if="agentsLoading">
      <Loader :loading="agentsLoading" />
    </div>

    <div v-else>
      <AddRAsset @onToggle="handleAddAssetToggle" />

      <!-- Service area toggle -->
      <ServiceAreaModal
        :serviceAreaArgs="serviceAreaArgs"
        ref="modal"
        id="v-step-0"
      />

      <BiocharQueryModal ref="biocharModal" @onQuery="handleBiocharQuery" />
      <div ref="viewDiv" id="viewDiv"></div>

      <!-- Toggle saDraw Button -->
      <ServiceAreaToggle :view="view" @onToggle="handleServiceAreaToggle" />
      <Loader :loading="loading" />
      <LightOverlay :loading="loading" />

      <!-- toggle between 2D and 3D -->
      <!-- <ToggleMap /> -->

      <Admin v-if="!isInvestorEmail" />
      <P1Summary v-show="showP1Summary" :showP1Summary="showP1Summary" @close="showP1Summary = false"/>
      <RFSummary v-show="showRFSummary" :showRFSummary="showRFSummary" @close="showRFSummary = false"/>
      <CFSummary v-show="showCFSummary" :showCFSummary="showCFSummary"  @close="showCFSummary = false"/>
      <MillClusteredSummary
        v-show="showClusteredMillSummary"
        :showClusteredMillSummary="showClusteredMillSummary"
        @close="showClusteredMillSummary = false"
      />
      <WardSummary
        v-show="showWardsSummary"
        :showWardsSummary="showWardsSummary"
        @close="showWardsSummary = false"
      />
      <NgnLGASummary
        v-show="showNgnLGASummary"
        :showNgnLGASummary="showNgnLGASummary"
        @close="showNgnLGASummary = false"
      />
      <CPOTaggedReleafSummary
        v-show="showCPOTaggedReleafSummary"
        :showCPOTaggedReleafSummary="showCPOTaggedReleafSummary"
         @close="showCPOTaggedReleafSummary = false"
      />
      <OilpalmClusterSummary
        v-show="showOilpalmClusterSummary"
        :showOilpalmClusterSummary="showOilpalmClusterSummary"
        @close="showOilpalmClusterSummary = false"
      />
      <DeforestedOilpalmClusterSummary
        v-show="showDeforestedOilpalmClusterSummary"
        :showDeforestedOilpalmClusterSummary="
          showDeforestedOilpalmClusterSummary
        "
        @close="showDeforestedOilpalmClusterSummary = false"
      />
      <BiocharAnalysisSummary
        v-if="showBiocharSummary"
        :show="showBiocharSummary"
        :factoryCount="biocharAnalysis.factoryCount"
        :totalFeedstockAvailable="biocharAnalysis.totalFeedstockAvailable"
        :maizeProduction="biocharAnalysis.maizeProduction"
        :pksProduction="biocharAnalysis.pksProduction"
        :factoryInputCapacity="biocharAnalysis.factoryInputCapacity"
        :maxBiocharOutput="biocharAnalysis.maxBiocharOutput"
        :factoryUtilization="biocharAnalysis.factoryUtilization"
        :productionStatus="biocharAnalysis.productionStatus"
        :radius="biocharAnalysis.radius"
        :unit="biocharAnalysis.unit"
        @close="showBiocharSummary = false"
      />
      <OfftakeSuitabilitySummary
        v-if="showOfftakeSummary"
        :show="showOfftakeSummary"
        :commercialFarmCount="offtakeSuitability.commercialFarmCount"
        :smallFarmCount="offtakeSuitability.smallFarmCount"
        :totalFarmArea="offtakeSuitability.totalFarmArea"
        :selectedBufferArea="offtakeSuitability.selectedBufferArea"
        :percentAreaUsed="offtakeSuitability.percentAreaUsed"
        :soilAnalysis="offtakeSuitability.soilAnalysis"
        :loading="isSoilAnalysisLoading"
        :biocharFacilities="biocharFacilities"
        :facilityLoading="facilityLoading"
        @close="showOfftakeSummary = false"
      />
      <RMSummary
        v-if="showRMSummary"
        :show="showRMSummary"
        :startDate="startDate"
        :endDate="endDate"
        :supplierName="supplierName"
        :community="community"
        @close="showRMSummary = false"
      />
      <BiocharLayerSummary
        v-if="showBiocharLayerSummary"
        :show="showBiocharLayerSummary"
        :startDate="biocharStartDate"
        :endDate="biocharEndDate"
        :selectedLga="selectedLga"
        :totalBiochar="biocharSummaryData.totalBiochar"
        :co2Removal="biocharSummaryData.co2Removal"
        :applicationCount="biocharSummaryData.applicationCount"
        @close="showBiocharLayerSummary = false"
      />
      <!-- map -->
      <div ref="map" id="map"></div>
    </div>

    <v-tour name="myTour" :steps="steps"></v-tour>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import axios_base_config_site, { getEmmisionsURL } from "@/config/api-config";
import {
  createStretchRenderer,
  createStopSymbol,
  calculateStats,
  generateSamplePoints,
  getBiocharDateRange,
  calculateBufferArea,
} from "@/views/mills/utils/map-helpers";

import {
  queryFacilityData,
  getBiocharRecommendation,
  calculateBiocharSummary,
  calculateFactoryMetrics,
  calculateOfftakeMetrics,
} from "@/views/mills/utils/query-helpers";

import {
  queryFactoryCount,
  queryMaizeProduction,
  queryOilPalmProduction,
  queryFarmCount,
  queryBiocharFacilities as queryBiocharFacilitiesHelper,
  querySinglePointSoilAnalysis,
} from "@/views/mills/utils/async-query-helpers";

import { getMillsAggregatedPurchases } from "../../utils";
import ServiceAreaToggle from "../../components/service-area/ServiceAreaToggle.vue";
import ServiceAreaModal from "../../components/service-area/ServiceAreaModal.vue";
import BiocharQueryModal from "../../components/service-area/BiocharQueryModal.vue";
import BiocharAnalysisSummary from "../../components/layer-summary/BiocharAnalysisSummary.vue";
import OfftakeSuitabilitySummary from "../../components/layer-summary/OfftakeSuitabilitySummary.vue";
import RMSummary from "@/components/layer-summary/rm-summary.vue";
import BiocharLayerSummary from "../../components/layer-summary/biochar-summary.vue";
import Loader from "../../components/loader/Loader.vue";
import LightOverlay from "../../components/loader/LightOverlay.vue";
import { APIKeys } from "../../config/keys";
import { oilPalmClusterURL, reverseGeocoding } from "../../config/api-config";
import TopNav from "../../layouts/TopNav.vue";
import AddRAsset from "../../components/releaf-assets/AddRAsset.vue";
import Admin from "../../components/admin-dashboard/Admin.vue";
import tourSteps from "@/data/intro/tour-steps";
import miniGridLayer from "@/views/mills/widgets/layer-list/minigrids";
import releafTaggedMillsLayer from "@/views/mills/widgets/layer-list/releaf-tagged-mills";
import p1AtField from "@/views/mills/widgets/layer-list/P1-in-field";
import rmSourceLayer from "@/views/mills/widgets/layer-list/rm-source";
import CPOMillsCluster from "@/views/mills/widgets/layer-list/cpo-mills-cluster";
import releafFactories from "@/views/mills/widgets/layer-list/releaf-factories";
import { biocharApplications } from "./widgets/layer-list/biochar-applications";
import lgaSummaryLayer from "@/views/mills/widgets/layer-list/lga-summary";
import oilPalmClusterLayer from "@/views/mills/widgets/layer-list/oil-palm-cluster";
import protectedArea from "@/views/mills/widgets/layer-list/protected-area";
import buildingFootprintLayer from "@/views/mills/widgets/layer-list/building-footprint";
import { communityPriceProjectionLayer } from "@/views/mills/widgets/layer-list/community-price-projection";
import stateBoundaryLayer from "@/views/mills/widgets/layer-list/state-boundary";
import lgaBoundaryLayer from "@/views/mills/widgets/layer-list/lga-boundary";
import wardBoundaryLayer from "@/views/mills/widgets/layer-list/ward-boundary";
import wardTaggedMillsLayer from "@/views/mills/widgets/layer-list/ward-tagged-mills";
import wardTonnesSourcedLayer from "@/views/mills/widgets/layer-list/ward-tonnes-sourced";
import wardMillClusterLayer from "@/views/mills/widgets/layer-list/ward-mill-clusters";
import wardAverageP1SourcedLayer from "@/views/mills/widgets/layer-list/ward-averagep1-sourced";
import customerFactoriesLayer from "@/views/mills/widgets/layer-list/customer-factories";
import hcvaLayer from "@/views/mills/widgets/layer-list/high-conservation-value-areas";
import hcsLayer from "@/views/mills/widgets/layer-list/high-carbon-stocks";
import industrialParksLayer from "@/views/mills/widgets/layer-list/industrial-parks";
import p1AggregatesLayer from "@/views/mills/widgets/layer-list/p1-aggregates";
import logisticsDepotLayer from "@/views/mills/widgets/layer-list/logistics-depot";
import { layerListActions } from "@/views/mills/widgets/layer-list/layer-list-base";
import { searchActions } from "@/views/mills/widgets/layer-list/search-sources";
import forestCoverLossLayer from "@/views/mills/widgets/layer-list/forest-cover-loss";
import forestCoverGainLayer from "@/views/mills/widgets/layer-list/forest-cover-gain";
import protectedConservedArea from "@/views/mills/widgets/layer-list/protected-oilpalm-area";
import P1Summary from "@/components/layer-summary/p1-at-field-summary.vue";
import RFSummary from "@/components/layer-summary/releaf-factory-summary.vue";
import CFSummary from "@/components/layer-summary/customer-factory-summary.vue";
import CPOTaggedReleafSummary from "@/components/layer-summary/cpo-tagged-summary.vue";
import OilpalmClusterSummary from "@/components/layer-summary/oilpalm-clusters-summary.vue";
import DeforestedOilpalmClusterSummary from "@/components/layer-summary/deforestedoilpalm-clusters-summary.vue";
import NgnLGASummary from "@/components/layer-summary/nigeria-lga-summary.vue";
import WardSummary from "@/components/layer-summary/nigeria-ward-summary.vue";
import MillClusteredSummary from "@/components/layer-summary/cpo-millsCluster-summary.vue";
import oilpalmSustainabilityLayer from "@/views/mills/widgets/layer-list/oilpalm-sustainability";
import millsDistanceLayer from "@/views/mills/widgets/layer-list/mills-distance";
import processedFactories from "./widgets/layer-list/biochar-factories";
import geoFencedFarms from "./widgets/layer-list/geofenced-farms";
import commercialFarms from "./widgets/layer-list/comercial-farms";

// maize layers
import processedMaizeLayer from "../maize/widgets/layer-list/maize-processed-yield";
import {
  maizeProduction2022Layer,
  maizeProduction2023Layer,
} from "../maize/widgets/layer-list/maize-prod";
import {
  sandTextureLayer,
  soilPHLayer,
  soilCarbonLayer,
  soilPHAfricaLayer,
} from "../maize/widgets/layer-list/soil-raster-analysis";
import MaizeYiedRasterLayer from "../maize/widgets/layer-list/maize-yield-raster";
import MaizeSuitabilityRasterLayer from "../maize/widgets/layer-list/maize-suitabilty-raster";
import maizeFarms from "../maize/widgets/layer-list/maize-farms";
import MaizeAreasRasterLayer from "../maize/widgets/layer-list/maize-areas-raster";
import oilPalmPolygonLayer from "./widgets/layer-list/merged-oil-palms";
import biocharPartners from "./widgets/layer-list/biochar-partners";

export default {
  name: "MyMap",
  components: {
    TopNav,
    Admin,
    ServiceAreaToggle,
    ServiceAreaModal,
    BiocharQueryModal,
    BiocharAnalysisSummary,
    OfftakeSuitabilitySummary,
    RMSummary,
    Loader,
    LightOverlay,
    AddRAsset,
    P1Summary,
    RFSummary,
    CFSummary,
    CPOTaggedReleafSummary,
    OilpalmClusterSummary,
    NgnLGASummary,
    WardSummary,
    MillClusteredSummary,
    DeforestedOilpalmClusterSummary,
    BiocharLayerSummary,
  },
  data() {
    return {
      myVariable: [],
      showP1Summary: false,
      showRFSummary: false,
      showCFSummary: false,
      showCPOTaggedReleafSummary: false,
      showOilpalmClusterSummary: false,
      showDeforestedOilpalmClusterSummary: false,
      showNgnLGASummary: false,
      showWardsSummary: false,
      showClusteredMillSummary: false,
      showBiocharSummary: false,
      isBufferActive: false,
      bufferCenter: null,
      bufferRadiusMeters: null,
      biocharAnalysis: {
        factoryCount: 0,
        totalFeedstockAvailable: 0,
        maizeProduction: 0,
        pksProduction: 0,
        factoryInputCapacity: 0,
        maxBiocharOutput: 0,
        factoryUtilization: 0,
        productionStatus: "",
        radius: 10,
        unit: "kilometers",
        show: false,
      },
      showOfftakeSummary: false,
      offtakeSuitability: {
        commercialFarmCount: 0,
        smallFarmCount: 0,
        totalFarmArea: 0,
        selectedBufferArea: 0,
        percentAreaUsed: 0,
        soilAnalysis: {
          pH: "N/A",
          sandTexture: "N/A",
          soilCarbon: "N/A",
          biocharRecommendation: "",
        },
      },
      isSoilAnalysisLoading: false,
      date: new Date().toISOString().substr(0, 10),
      futurePriceP1: [],
      currentPriceP1: [],
      showDate: false,
      showDeleteAssetPrompt: false,
      list: [],
      view: null,
      map: null,
      serviceArea: null,
      geometryEngine: null,
      currentBiocharGraphic: null,
      bufferLayer: null,
      Graphic: null,
      currentBufferGraphic: null,
      serviceAreaStartingPoint: {},
      serviceAreaParams: null,
      locationGraphic: null,
      outSpatialReference: null,
      FeatureSet: null,
      driveTimeCutoffs: [0, 0, 0],
      saToggle: false,
      addAssetToogle: false,
      toggleFilterForm: false,
      serviceAreaValue: 0,
      loading: false,
      mills: [],
      oilpalmClusters: [],
      cluster: {},
      serviceAreaArgs: {},
      showServiceAreaModal: false,
      steps: tourSteps,
      agentsLoading: false,
      user: null,
      maize2022ProductionLayer: null,
      maize2023ProductionLayer: null,
      layerList: null,
      startDate: null,
      endDate: null,
      supplierName: null,
      community: null,
      showRMSummary: false,
      biocharFacilities: [],
      facilityLoading: false,
      showBiocharLayerSummary: false,
      biocharActiveFilter: null,
      biocharStartDate: null,
      biocharEndDate: null,
      selectedLga: null,
      biocharSummaryData: {
        totalBiochar: 0,
        co2Removal: 0,
        applicationCount: 0,
        locationCount: 0,
      },
      emissionsData: null,
    };
  },

  async mounted() {
    try {
      this.agentsLoading = true;
      this.user = this.$store.getters["auth/currentUser"];
      const response = await this.$store.dispatch("auth/fetchAgents");
      console.log(response);
      this.agentsLoading = false;
    } catch (error) {
      console.error("Error fetching agents:", error);
    }
    this.loadMap();
    this.fetchMillsAggregatedPurchases();
    this.fetchOilpalmClusters(oilPalmClusterURL);
    await this.fetchEmissionsData();

    if (!(JSON.parse(localStorage.getItem("first_time")) === true)) {
      this.$tours["myTour"].start();
      localStorage.setItem("first_time", JSON.stringify(true));
    }
  },

  beforeCreate() {
    this.$store.dispatch("inventory/fetchInventorySummaryPerAgent");
    this.$store.dispatch("inventory/fetchInventoryInField");
  },

  computed: {
    updatedMills() {
      return this.$store.getters["mills/getFilteredMills"];
    },
    millsFilterStatus() {
      return this.$store.getters["mills/getFilterStatus"];
    },
    divideServiceAreaValue() {
      return Math.round(Number(this.serviceAreaValue));
    },
    markers() {
      return this.$store.getters["markers/getAllMarkers"];
    },
    isInvestorEmail() {
      return this.user && this.user.email === "investor@releaf.ng";
    },
  },

  methods: {
    showDateFx() {
      this.showDate = !this.showDate;
      this.show = !this.showDate;
    },
    showDateOff() {
      this.showDate = false;
    },
    setDate() {
      this.$store.dispatch("serviceArea/setFuturePrice", this.date);
      this.showDateOff();
    },
    handleServiceAreaToggle(status) {
      this.saToggle = status;
    },
    handleAddAssetToggle(status) {
      this.addAssetToggle = status;
      this.openCoordinateForm = status;
    },
    handleFilterToggle(status) {
      this.toggleFilterForm = status;
    },

    async fetchEmissionsData() {
      try {
        const emissionsResponse = await axios_base_config_site.get(getEmmisionsURL);
        this.emissionsData = emissionsResponse.data;
        console.log("Emissions data fetched and cached:", this.emissionsData);
      } catch (error) {
        console.error("Error fetching emissions data:", error);
        this.emissionsData = null;
      }
    },

    async fetchOilpalmClusters(url) {
      try {
        this.oilpalmClusters = await this.$store.dispatch(
          "oilpalmClusters/getOilPalmClusters",
          url
        );
      } catch (err) {
        console.log(err);
      }
    },

    // ─── RM Source layer filters
    async applyFilters() {
      try {
        if (!this.startDate && !this.endDate && !this.supplierName && !this.community) {
          this.$toastr.e("Please select at least one filter criterion");
          return;
        }
        if (
          this.startDate &&
          this.endDate &&
          new Date(this.startDate) > new Date(this.endDate)
        ) {
          this.$toastr.e("End date must be after start date");
          return;
        }

        const layer = this.map.findLayerById("rmSourceLayer");
        if (!layer) {
          this.$toastr.e("Layer not found");
          return;
        }

        await layer.when();
        const dateField = layer.fields.find((f) => f.name === "date");
        if (!dateField) {
          this.$toastr.e("Date field not found in layer");
          return;
        }

        this.loading = true;
        let whereClause = "1=1";

        if (
          this.startDate &&
          this.endDate &&
          !isNaN(new Date(this.startDate).getTime()) &&
          !isNaN(new Date(this.endDate).getTime())
        ) {
          const startDate = new Date(this.startDate).toISOString().split("T")[0];
          const endDate = new Date(this.endDate).toISOString().split("T")[0];
          whereClause +=
            dateField.type === "date"
              ? ` AND date >= DATE '${startDate}' AND date <= DATE '${endDate}'`
              : ` AND date >= '${startDate}T00:00:00.000Z' AND date <= '${endDate}T23:59:59.999Z'`;
        }

        if (this.supplierName && this.supplierName.trim()) {
          whereClause += ` AND supplierName = '${this.supplierName.trim().replace(/'/g, "''")}'`;
        }
        if (this.community && this.community.trim()) {
          whereClause += ` AND community = '${this.community.trim().replace(/'/g, "''")}'`;
        }

        layer.definitionExpression = whereClause;
        const count = await layer.queryFeatureCount({ where: whereClause });

        if (count === 0) {
          this.$toastr.w("No purchases found for the selected filters");
        } else {
          const filterInfo = [];
          if (this.startDate && this.endDate)
            filterInfo.push(`Date: ${this.startDate} to ${this.endDate}`);
          if (this.supplierName) filterInfo.push(`Supplier: ${this.supplierName}`);
          if (this.community) filterInfo.push(`Community: ${this.community}`);
          this.$toastr.s(`Filter applied (${filterInfo.join(", ")}): ${count} purchases found`);
        }
      } catch (error) {
        console.error("Filter error:", error.message);
        this.$toastr.e("Filter failed: " + error.message);
      } finally {
        this.loading = false;
      }
    },

    async clearDateFilter() {
      this.loading = true;
      try {
        const layer = this.map.findLayerById("rmSourceLayer");
        if (layer) layer.definitionExpression = null;
        this.startDate = null;
        this.endDate = null;
        this.supplierName = null;
        this.community = null;
        this.$toastr.s("All filters cleared");
      } catch (error) {
        console.error("Clear filter error:", error);
        this.$toastr.e("Failed to clear filters");
      } finally {
        this.loading = false;
      }
    },
    async queryBiocharFacilities(rAssetsLayer) {
      await queryBiocharFacilitiesHelper(rAssetsLayer, this);
    },

    showModal() {
      this.$refs["modal"].showModal();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },

    handleBiocharQuery({ radius, unit }) {
      if (this.currentBiocharGraphic) {
        this.queryNearbyFactories(
          this.currentBiocharGraphic.geometry,
          radius,
          unit,
          this.currentBiocharLayer
        );
      }
    },

    clearBuffer() {
      if (this.currentBufferGraphic) {
        this.view.graphics.remove(this.currentBufferGraphic);
        this.currentBufferGraphic = null;
      }
      if (this.view.popup) this.view.popup.close();
      this.isBufferActive = false;
      this.bufferCenter = null;
      this.bufferRadiusMeters = null;
      this.showOfftakeSummary = false;
      this.offtakeSuitability = {};
    },

    async queryNearbyFactories(point, radius, unit) {
  if (!this.currentBiocharGraphic) {
    console.warn("No biochar graphic selected");
    return;
  }

  const radiusInMeters = unit === "kilometers" ? radius * 1000 : radius * 1609.34;
  const buffer = this.geometryEngine.buffer(point, radiusInMeters, "meters");

  if (this.currentBufferGraphic) {
    this.view.graphics.remove(this.currentBufferGraphic);
    this.currentBufferGraphic = null;
  }

  const bufferGraphic = new this.Graphic({
    geometry: buffer,
    symbol: {
      type: "simple-fill",
      color: [255, 255, 0, 0.2],
      outline: { color: [0, 0, 255], width: 1 },
    },
  });
  this.view.graphics.add(bufferGraphic);
  this.currentBufferGraphic = bufferGraphic;

  this.isBufferActive = true;
  this.bufferCenter = point;
  this.bufferRadiusMeters = radiusInMeters;

  try {
    const facilityData = queryFacilityData(this.currentBiocharGraphic);
    const [factoryCount, maizeProduction, oilPalmProduction] = await Promise.all([
      queryFactoryCount(buffer, this.map.findLayerById("processingFactories")),
      queryMaizeProduction(buffer, this.map.findLayerById("maizeLayer")),
      queryOilPalmProduction(buffer, this.map.findLayerById("oilPalmPolygonLayer")),
    ]);
    this.displayResults(factoryCount, maizeProduction, oilPalmProduction, facilityData, radius, unit);
  } catch (error) {
    console.error("Query error:", error);
  }
},

    displayResults(factoryCount, maizeProduction, oilPalmProduction, facilityData, radius, unit) {
      const metrics = calculateFactoryMetrics(
        factoryCount,
        maizeProduction,
        oilPalmProduction,
        facilityData.processedVolume
      );
      this.biocharAnalysis = { ...metrics, radius, unit, show: true };
      this.showBiocharSummary = true;
    },

    // ─── Offtake suitability 
    async queryOfftakeSuitability(buffer, point) {
      try {
        const radius = 50;
        const unit = "kilometers";
        this.isSoilAnalysisLoading = true;

        const [commercialFarmCount, smallFarmCount, totalFarmArea, soilAnalysis] =
          await Promise.all([
            queryFarmCount(buffer, this.map.findLayerById("commercialFarm")),
            queryFarmCount(buffer, this.map.findLayerById("maizeFarm")),
            this.queryTotalFarmArea(buffer),
            this.querySoilAnalysis(point, radius, unit),
          ]);

        const bufferAreaHectares = calculateBufferArea(this.geometryEngine, buffer, "hectares");
        const offtakeMetrics = calculateOfftakeMetrics(
          commercialFarmCount,
          smallFarmCount,
          totalFarmArea,
          bufferAreaHectares
        );

        this.offtakeSuitability = {
          ...offtakeMetrics,
          soilAnalysis: {
            pH: soilAnalysis.pH || "N/A",
            sandTexture: soilAnalysis.sandTexture || "N/A",
            soilCarbon: soilAnalysis.soilCarbon || "N/A",
            biocharRecommendation: getBiocharRecommendation(soilAnalysis),
          },
        };

        this.showOfftakeSummary = true;
      } catch (error) {
        console.error("Error querying offtake suitability:", error);
      } finally {
        this.isSoilAnalysisLoading = false;
      }
    },
    async queryTotalFarmArea(buffer) {
      const layerConfigs = [
        { id: "commercialFarm", field: "Farm_Size_hectares_", defaultArea: 10 },
        { id: "maizeFarm", field: null, defaultArea: 1 },
      ];
      let totalArea = 0;

      for (const config of layerConfigs) {
        const layer = this.map.findLayerById(config.id);
        if (!layer) {
          console.warn(`Layer ${config.id} not found`);
          continue;
        }

        const query = layer.createQuery();
        query.geometry = buffer;
        query.spatialRelationship = "intersects";

        try {
          if (config.field) {
            query.outFields = [config.field];
            query.returnGeometry = false;
            const response = await layer.queryFeatures(query);
            totalArea += response.features.reduce((sum, feature) => {
              const areaValue = feature.attributes[config.field];
              const area =
                typeof areaValue === "number" && !isNaN(areaValue)
                  ? areaValue
                  : config.defaultArea;
              return sum + area;
            }, 0);
          } else {
            const farmCount = await layer.queryFeatureCount(query);
            totalArea += farmCount * config.defaultArea;
          }
        } catch (error) {
          console.error(`Error querying area for ${config.id}:`, error);
        }
      }

      return totalArea;
    },

    // ─── Soil analysis 
    async querySoilAnalysis(point, radius = 50000, unit = "meters") {
      const radiusMeters = unit === "kilometers" ? radius * 1000 : radius;
      const bufferArea = (Math.PI * radiusMeters * radiusMeters) / 1e6;
      const sampleCount = Math.min(100, Math.ceil(bufferArea / 1));
      const results = {};

      if (!this.view?.ready || !this.view.spatialReference || !point) {
        console.warn("Map view not ready or invalid spatial reference/point");
        ["pH", "sandTexture", "soilCarbon"].forEach((k) => (results[k] = "N/A"));
        return results;
      }

      try {
        const buffer = this.geometryEngine.buffer(point, radiusMeters, "meters");
        if (!buffer) {
          console.warn("Failed to create buffer");
          ["pH", "sandTexture", "soilCarbon"].forEach((k) => (results[k] = "N/A"));
          return results;
        }

        const samples = generateSamplePoints(this.geometryEngine, buffer, sampleCount);
        const values = { pH: [], sandTexture: [], soilCarbon: [] };


        const sampleResults = await Promise.all(
          samples.map((samplePoint) =>
            querySinglePointSoilAnalysis(samplePoint, this.map, this.view)
          )
        );

        for (const pointResults of sampleResults) {
          if (pointResults.pH !== "N/A") values.pH.push(parseFloat(pointResults.pH));
          if (pointResults.sandTexture !== "N/A")
            values.sandTexture.push(parseFloat(pointResults.sandTexture));
          if (pointResults.soilCarbon !== "N/A")
            values.soilCarbon.push(parseFloat(pointResults.soilCarbon));
        }

        results.pH = calculateStats(values.pH);
        results.sandTexture = calculateStats(values.sandTexture);
        results.soilCarbon = calculateStats(values.soilCarbon);
      } catch (err) {
        console.error("Error in buffered soil analysis:", err);
        ["pH", "sandTexture", "soilCarbon"].forEach((k) => (results[k] = "N/A"));
      }

      return results;
    },

    // ─── Biochar layer summary 
    async loadBiocharSummaryData(startDate = null, endDate = null, lga = null, community = null) {
      try {
        const biocharLayer = this.map.findLayerById("biocharApplications");
        if (!biocharLayer) {
          console.error("Biochar layer not found");
          return;
        }

        const query = biocharLayer.createQuery();
        let whereClause = "1=1";

        if (startDate && endDate) {
          whereClause += ` AND startDate >= '${startDate}' AND endDate <= '${endDate}'`;
        }
        if (lga) {
          whereClause += ` AND lga = '${lga.replace(/'/g, "''")}'`;
        }
        if (community) {
          whereClause += ` AND community = '${community.replace(/'/g, "''")}'`;
        }

        query.where = whereClause;
        query.outFields = [
          "amountOfBiochar",
          "bikeEmissions",
          "startDate",
          "endDate",
          "truckEmissions",
          "netCo2",
          "lga",
          "batchIds",
        ];
        query.returnGeometry = false;

        const response = await biocharLayer.queryFeatures(query);
        const summaryData = calculateBiocharSummary(response.features, this.emissionsData);

        this.biocharSummaryData = summaryData;
        this.selectedLga = lga;

        if (!startDate && !endDate && !lga && response.features.length > 0) {
          const dates = response.features
            .map((f) => f.attributes.startDate)
            .filter((d) => d)
            .sort();
          if (dates.length > 0) {
            this.biocharStartDate = dates[0];
            this.biocharEndDate = dates[dates.length - 1];
          }
        }
      } catch (error) {
        console.error("Error querying biochar summary data:", error);
        this.biocharSummaryData = { totalBiochar: 0, co2Removal: 0, applicationCount: 0 };
      }
    },

    clearBiocharFilter() {
      const biocharLayer = this.map.findLayerById("biocharApplications");
      if (biocharLayer) {
        biocharLayer.definitionExpression = null;
        this.biocharStartDate = null;
        this.biocharEndDate = null;
        this.selectedLga = null;
        this.loadBiocharSummaryData();
      }
    },

    applyBiocharPredefinedDateFilter(filterType, lga = null, community = null) {
      const { start, end } = getBiocharDateRange(filterType);
      if (start && end) {
        const startUTC = new Date(start.getTime() - 1 * 60 * 60 * 1000);
        const endUTC = new Date(end.getTime() - 1 * 60 * 60 * 1000);
        this.biocharStartDate = startUTC.toISOString();
        this.biocharEndDate = endUTC.toISOString();
        this.applyBiocharDateFilter(lga, community);
      }
    },

    applyBiocharLgaFilter(lga) {
      const biocharLayer = this.map.findLayerById("biocharApplications");
      if (biocharLayer) {
        biocharLayer.definitionExpression = `lga = '${lga.replace(/'/g, "''")}'`;
        this.loadBiocharSummaryData(null, null, lga);
      }
    },

    applyBiocharCommunityFilter(community) {
      const biocharLayer = this.map.findLayerById("biocharApplications");
      if (biocharLayer) {
        biocharLayer.definitionExpression = `community = '${community.replace(/'/g, "''")}'`;
        this.loadBiocharSummaryData(null, null, null, community);
      }
    },

    applyBiocharDateFilter(lga = null, community = null) {
      if (!this.biocharStartDate || !this.biocharEndDate) {
        this.clearBiocharFilter();
        return;
      }

      let startDateFormatted, endDateFormatted;

      if (this.biocharStartDate.includes("T")) {
        startDateFormatted = this.biocharStartDate;
        endDateFormatted = this.biocharEndDate;
      } else {
        const startLocal = new Date(this.biocharStartDate + "T00:00:00");
        const endLocal = new Date(this.biocharEndDate + "T23:59:59.999");
        startDateFormatted = new Date(startLocal.getTime() - 1 * 60 * 60 * 1000).toISOString();
        endDateFormatted = new Date(endLocal.getTime() - 1 * 60 * 60 * 1000).toISOString();
      }

      const biocharLayer = this.map.findLayerById("biocharApplications");
      if (biocharLayer) {
        let whereClause = `startDate >= '${startDateFormatted}' AND endDate <= '${endDateFormatted}'`;
        if (lga) whereClause += ` AND lga = '${lga.replace(/'/g, "''")}'`;
        if (community) whereClause += ` AND community = '${community.replace(/'/g, "''")}'`;
        biocharLayer.definitionExpression = whereClause;
        this.loadBiocharSummaryData(startDateFormatted, endDateFormatted, lga);
      }
    },

    loadMap() {
      loadModules(
        [
          "esri/config",
          "esri/Map",
          "esri/views/MapView",
          "esri/rest/serviceArea",
          "esri/Graphic",
          "esri/rest/support/FeatureSet",
          "esri/rest/support/ServiceAreaParameters",
          "esri/widgets/Home",
          "esri/widgets/Search",
          "esri/widgets/LayerList",
          "esri/widgets/Expand",
          "esri/layers/FeatureLayer",
          "esri/widgets/BasemapToggle",
          "esri/widgets/ScaleBar",
          "esri/widgets/Slider",
          "esri/widgets/BasemapGallery",
          "esri/layers/GeoJSONLayer",
          "esri/widgets/Directions",
          "esri/symbols/SimpleMarkerSymbol",
          "esri/rest/locator",
          "esri/layers/GroupLayer",
          "esri/layers/ImageryTileLayer",
          "esri/renderers/RasterStretchRenderer",
          "esri/geometry/geometryEngine",
          "esri/layers/GraphicsLayer",
        ],
        { css: true }
      ).then(
        ([
          esriConfig,
          ArcGISMap,
          MapView,
          serviceArea,
          Graphic,
          FeatureSet,
          ServiceAreaParams,
          Home,
          Search,
          LayerList,
          Expand,
          FeatureLayer,
          BasemapToggle,
          ScaleBar,
          Slider,
          BasemapGallery,
          GeoJSONLayer,
          Directions,
          SimpleMarkerSymbol,
          locator,
          GroupLayer,
          ImageryTileLayer,
          RasterStretchRenderer,
          geometryEngine,
        ]) => {
          esriConfig.apiKey = APIKeys;
          this.geometryEngine = geometryEngine;
          this.Graphic = Graphic;

          // ── GeoJSONLayer layers
          const RFTaggedMills = new GeoJSONLayer(releafTaggedMillsLayer);
          const p1Aggregates = new GeoJSONLayer(p1AggregatesLayer);
          const rAssets = new GeoJSONLayer({ ...releafFactories, id: "rAssets" });
          this.queryBiocharFacilities(rAssets);

          const biocharApplicationsLayer = new GeoJSONLayer({
            ...biocharApplications,
            id: "biocharApplications",
            outFields: ["*"],
          });
          const P1AtField = new GeoJSONLayer(p1AtField);
          const logisticsDepot = new GeoJSONLayer(logisticsDepotLayer);
          const customerFactories = new GeoJSONLayer(customerFactoriesLayer);
          const futurePriceLayer = new GeoJSONLayer(communityPriceProjectionLayer(this.date));
          const RawMaterials = new GeoJSONLayer(rmSourceLayer);
          RawMaterials.viewModel = this;
          const biocharPartnerLayer = new GeoJSONLayer({ ...biocharPartners, id: "biocharPartners" });

          // ── ImageryTileLayer layers 
          const soilPHNigeria = new ImageryTileLayer({
            id: "soilPHNigeria",
            url: soilPHLayer.url,
            opacity: soilPHLayer.opacity,
            visible: soilPHLayer.visible,
            title: soilPHLayer.title,
            popupTemplate: soilPHLayer.popupTemplate,
            renderer: new RasterStretchRenderer(
              createStretchRenderer(0, 14, [255, 99, 71, 255], [50, 205, 50, 255])
            ),
          });

          const soilPHAfrica = new ImageryTileLayer({
            url: soilPHAfricaLayer.url,
            opacity: soilPHAfricaLayer.opacity,
            visible: soilPHAfricaLayer.visible,
            title: soilPHAfricaLayer.title,
            popupTemplate: soilPHAfricaLayer.popupTemplate,
            renderer: new RasterStretchRenderer(
              createStretchRenderer(0, 14, [255, 99, 71, 255], [50, 205, 50, 255])
            ),
          });

          const soilCarbon = new ImageryTileLayer({
            id: "soilCarbon",
            url: soilCarbonLayer.url,
            opacity: soilCarbonLayer.opacity,
            visible: soilCarbonLayer.visible,
            title: soilCarbonLayer.title,
            popupTemplate: soilCarbonLayer.popupTemplate,
            renderer: new RasterStretchRenderer(
              createStretchRenderer(0, 100, [211, 211, 211, 255], [138, 43, 226, 255])
            ),
          });

          const sandTexture = new ImageryTileLayer({
            id: "sandTexture",
            url: sandTextureLayer.url,
            opacity: sandTextureLayer.opacity,
            visible: sandTextureLayer.visible,
            title: sandTextureLayer.title,
            popupTemplate: sandTextureLayer.popupTemplate,
            renderer: new RasterStretchRenderer(
              createStretchRenderer(0, 100, [220, 20, 60, 255], [50, 205, 50, 255])
            ),
          });

          const maizeYieldRaster = new ImageryTileLayer({
            url: MaizeYiedRasterLayer.url,
            opacity: MaizeYiedRasterLayer.opacity,
            visible: MaizeYiedRasterLayer.visible,
            title: MaizeYiedRasterLayer.title,
            popupTemplate: MaizeYiedRasterLayer.popupTemplate,
            renderer: new RasterStretchRenderer(
              createStretchRenderer(1, 12, [139, 105, 20, 255], [255, 215, 0, 255])
            ),
          });

          const maizeSuitabilityRaster = new ImageryTileLayer({
            url: MaizeSuitabilityRasterLayer.url,
            opacity: MaizeSuitabilityRasterLayer.opacity,
            visible: MaizeSuitabilityRasterLayer.visible,
            title: MaizeSuitabilityRasterLayer.title,
            popupTemplate: MaizeSuitabilityRasterLayer.popupTemplate,
            renderer: new RasterStretchRenderer(
              createStretchRenderer(0, 10000, [255, 0, 0, 255], [0, 128, 0, 255])
            ),
          });

          const maizeArea = new ImageryTileLayer({
            url: MaizeAreasRasterLayer.url,
            title: MaizeAreasRasterLayer.title,
            opacity: MaizeAreasRasterLayer.opacity,
            visible: MaizeAreasRasterLayer.visible,
            renderer: new RasterStretchRenderer(
              createStretchRenderer(1, 0, [255, 215, 0, 255], [255, 255, 0, 255])
            ),
          });

          // ── FeatureLayer layers
          const oilpalmSustainability = new FeatureLayer(oilpalmSustainabilityLayer);
          const protetectedOilpalm = new FeatureLayer(protectedConservedArea);
          const miniGrids = new FeatureLayer(miniGridLayer);
          const RFTaggedMillsClustered = new FeatureLayer(CPOMillsCluster);
          const lgaOilPalm = new FeatureLayer(lgaSummaryLayer);
          const palmoilclusterFL = new FeatureLayer({ ...oilPalmClusterLayer, id: "oilPalmClusterLayer" });
          const oilPalmPolygon = new FeatureLayer({ ...oilPalmPolygonLayer, id: "oilPalmPolygonLayer" });
          const oilPalmYields = oilPalmPolygon.clone();
          const protectedAreas = new FeatureLayer(protectedArea);
          const buildingFP = new FeatureLayer(buildingFootprintLayer);
          const stateBoundary = new FeatureLayer(stateBoundaryLayer);
          const lgaBoundary = new FeatureLayer(lgaBoundaryLayer);
          const forestCoverLoss = new FeatureLayer(forestCoverLossLayer);
          const forestCoverGain = new FeatureLayer(forestCoverGainLayer);
          const wardBoundary = new FeatureLayer(wardBoundaryLayer);
          const wardTaggedMills = new FeatureLayer(wardTaggedMillsLayer);
          const wardTonnesSourced = new FeatureLayer(wardTonnesSourcedLayer);
          const wardMillClusters = new FeatureLayer(wardMillClusterLayer);
          const highConservationValueArea = new FeatureLayer(hcvaLayer);
          const highCarbonStocks = new FeatureLayer(hcsLayer);
          const industrialParks = new FeatureLayer(industrialParksLayer);
          const wardAverageP1Purchased = new FeatureLayer(wardAverageP1SourcedLayer);
          const millsDistance = new FeatureLayer(millsDistanceLayer);
          const processingFactories = new FeatureLayer({ ...processedFactories, id: "processingFactories" });
          const geoFencedFarm = new FeatureLayer(geoFencedFarms);
          const commercialFarm = new FeatureLayer({ ...commercialFarms, id: "commercialFarm" });

          this.maize2022ProductionLayer = new FeatureLayer(maizeProduction2022Layer);
          this.maize2023ProductionLayer = new FeatureLayer({ ...maizeProduction2023Layer, id: "maizeLayer" });
          const maizeFarmTrials = new FeatureLayer(processedMaizeLayer);
          const maizeFarm = new FeatureLayer({ ...maizeFarms, id: "maizeFarm" });
          const maize2022 = this.maize2022ProductionLayer;
          const maize2023 = this.maize2023ProductionLayer;

          this.cluster = palmoilclusterFL;

  
          const lgaNest = new GroupLayer({
            title: "Nigeria LGA Layer",
            visible: true,
            visibilityMode: "exclusive",
            layers: [lgaOilPalm, lgaBoundary],
          });

          const wardNest = new GroupLayer({
            title: "Nigeria Ward Layer",
            visible: true,
            visibilityMode: "exclusive",
            layers: [wardAverageP1Purchased, wardMillClusters, wardTonnesSourced, wardTaggedMills, wardBoundary],
          });

          const infrastructure = new GroupLayer({
            title: "Infrastructure",
            visible: true,
            visibilityMode: "exclusive",
            layers: [miniGrids, industrialParks, customerFactories, biocharPartnerLayer],
          });

          const FeedStockLayers = new GroupLayer({
            id: "feedStockLayers",
            title: "Feedstock Layers",
            visibilityMode: "independent",
            visible: false,
            layers: [maize2023, oilPalmYields, processingFactories],
          });

          const OffTakeLayers = new GroupLayer({
            id: "offtakeLayers",
            title: "Offtake Layers",
            visibilityMode: "independent",
            visible: false,
            layers: [soilPHNigeria, soilCarbon, sandTexture, commercialFarm, geoFencedFarm, maizeFarm],
          });

          const BiocharProjectLayers = new GroupLayer({
            id: "biocharProjectLayers",
            title: "Biochar Project Layers",
            visibilityMode: "exclusive",
            visible: false,
            layers: [OffTakeLayers, FeedStockLayers],
          });

          FeedStockLayers.visible = true;
          OffTakeLayers.visible = false;

          const layerSelectionState = {
            FeedStock: new Set(["all"]),
            OffTake: new Set(["all"]),
          };

          BiocharProjectLayers.watch("visible", (newValue) => {
            if (newValue) {
              FeedStockLayers.visible = true;
              OffTakeLayers.visible = false;
              const showAll = layerSelectionState.FeedStock.has("all");
              FeedStockLayers.layers.forEach((layer) => {
                layer.visible = showAll || layerSelectionState.FeedStock.has(layer.title);
              });
            }
          });

          FeedStockLayers.watch("visible", (newValue) => {
            if (newValue) {
              const showAll = layerSelectionState.FeedStock.has("all");
              FeedStockLayers.layers.forEach((layer) => {
                layer.visible = showAll || layerSelectionState.FeedStock.has(layer.title);
              });
            }
          });

          OffTakeLayers.watch("visible", (newValue) => {
            if (newValue) {
              const showAll = layerSelectionState.OffTake.has("all");
              OffTakeLayers.layers.forEach((layer) => {
                layer.visible = showAll || layerSelectionState.OffTake.has(layer.title);
              });
            }
          });

          // ── Create the map and add layers based on user role
          this.map = new ArcGISMap({
            basemap: "arcgis-nova",
            layers:
              this.user.email === "investor@releaf.ng"
                ? [RFTaggedMills, rAssets, protectedAreas, oilPalmPolygon, protetectedOilpalm, oilpalmSustainability]
                : [
                    RFTaggedMills,
                    stateBoundary,
                    maizeArea,
                    maizeFarmTrials,
                    maizeYieldRaster,
                    maizeSuitabilityRaster,
                    soilPHAfrica,
                    lgaNest,
                    wardNest,
                    logisticsDepot,
                    p1Aggregates,
                    futurePriceLayer,
                    buildingFP,
                    highCarbonStocks,
                    highConservationValueArea,
                    forestCoverLoss,
                    forestCoverGain,
                    infrastructure,
                    RFTaggedMillsClustered,
                    millsDistance,
                    rAssets,
                    protectedAreas,
                    protetectedOilpalm,
                    P1AtField,
                    oilPalmPolygon,
                    oilpalmSustainability,
                    RawMaterials,
                    biocharApplicationsLayer,
                    BiocharProjectLayers,
                  ],
          });

          this.$store.dispatch("arcgisMap/saveLayers", this.map.layers._items);

          maize2022.listMode = "hide-children";
          maize2023.listMode = "hide-children";

          // ── Create map view 
          this.view = new MapView({
            container: this.$el,
            map: this.map,
            center: [6.535123, 6.153788],
            zoom: 7.6,
          });

          this.view.popup.on("trigger-action", (event) => {
            if (event.action.id === "edit-this") this.showDateFx();
          });

          // ── Widgets
          const basemapToggle = new BasemapToggle({
            view: this.view,
            nextBasemap: "arcgis-imagery",
          });

          const layerList = new LayerList({
            view: this.view,
            listItemCreatedFunction: defineActions,
          });

          layerList.on("trigger-action", (event) => {
            if (event.action.id === "toggle-panel") {
              const item = event.item;
              item.panel.open = !item.panel.open;
            }
          });

          this.$store.dispatch("arcgisMap/saveView", this.view);

          let homeWidget = new Home({ view: this.view });

          const searchItems = searchActions(rAssets, RFTaggedMills, APIKeys, biocharApplicationsLayer);
          let searchWidget = new Search({
            view: this.view,
            includeDefaultSources: false,
            sources: searchItems.searchComponents,
          });

          let basemapGallery = new BasemapGallery({ view: this.view });
          const basemapGalleryExpand = new Expand({
            expandIconClass: "esri-icon-collection",
            view: this.view,
            content: basemapGallery,
            group: "top-left",
            expandTooltip: "Basemap gallery",
          });

          const layerListExpand = new Expand({
            expandIconClass: "esri-icon-layers",
            view: this.view,
            content: layerList,
            group: "top-left",
            expandTooltip: "Layers List",
          });

          const routeDirection = new Directions({
            view: this.view,
            routeServiceUrl:
              "https://route-api.arcgis.com/arcgis/rest/services/World/Route/NAServer/Route_World/",
          });

          const createSimpleStopSymbol = (outline, fill, size) =>
            new SimpleMarkerSymbol(createStopSymbol(outline, fill, size));

          routeDirection.stopSymbols.first = createSimpleStopSymbol("black", "white", "120px");
          routeDirection.stopSymbols.middle = createSimpleStopSymbol("grey", "white", "10px");
          routeDirection.stopSymbols.last = createSimpleStopSymbol("white", "black", "12px");
          routeDirection.routeSymbol.width = "5";
          routeDirection.routeSymbol.color = [34, 131, 38, 0.8];
          routeDirection.routeSymbol.style = "solid";

          // ── Layer-list slider / filter state
          let weeklyP1YieldSlider;
          let p1LGASummarySlider;
          let oilPalmClusterSlider;
          let buidingFootprintSlider;
          let daysSinceLastDiscoverySlider;
          let tonnesBoughtTaggedMillsSlider;
          let numberOfTxnSlider;
          let aveP1PerMillSlider;
          let sliderTonnesAtField;
          let sliderDaysSincePurchase;
          let toast = this.$toastr;
          let self = this;

          async function defineActions(event) {
            const __ret = layerListActions(
              event,
              weeklyP1YieldSlider,
              Slider,
              oilPalmClusterSlider,
              p1LGASummarySlider,
              buidingFootprintSlider,
              daysSinceLastDiscoverySlider,
              tonnesBoughtTaggedMillsSlider,
              numberOfTxnSlider,
              aveP1PerMillSlider,
              sliderTonnesAtField,
              sliderDaysSincePurchase,
              pickupVehicleCheckboxes,
              agentsDropdownList,
              customerFactoryTypeFilter,
              customerFactoryTypeFilterReset,
              releafFactoryTypeFilter,
              releafFactoryTypeFilterReset,
              p1AtFieldReset,
              cpoTaggedMillsFilterReset,
              gtForDaySinceLastPurchase,
              ltForDaySinceLastPurchase,
              gtForTonnesPurchased,
              ltForTonnesPurchased,
              customerFactoryStatusFilter,
              processedFactoryStatusFilter,
              processedFarmStatusFilter,
              releafFactoryStatusFilter,
              gtDaysSinceLastDiscovery,
              ltDaysSinceLastDiscovery,
              gtTonnesBoughtTaggedMills,
              ltTonnesBoughtTaggedMills,
              gtNumberOfTxn,
              ltNumberOfTxn,
              gtAveP1PerMill,
              ltAveP1PerMill,
              gtBuidingFootprint,
              ltBuidingFootprint,
              gtWeeklyP1Yield,
              ltWeeklyP1Yield,
              gtOilPalmCluster,
              ltOilPalmCluster,
              gtP1LGASummary,
              ltP1LGASummary,
              oilPalmClusterReset,
              handleShowP1Summary,
              handleReleafFactorySummary,
              handleCustomerFactorySummary,
              handleCPOTaggedReleafSummary,
              handleOilpalmClusterSummary,
              handlesNgnLGASummary,
              handlesWardsSummary,
              handleClusteredMillSummary,
              handleDeforestedOilpalmClusterSummary,
              handleRMSummary,
              maize2022,
              maize2023,
              RasterStretchRenderer,
              toast,
              handleShowBiocharLayerSummary,
              biocharPartnersFilter,
              biocharTypeFilter,
              self
            );

            weeklyP1YieldSlider = __ret.weeklyP1YieldSlider;
            oilPalmClusterSlider = __ret.oilPalmClusterSlider;
            p1LGASummarySlider = __ret.p1LGASummarySlider;
            buidingFootprintSlider = __ret.buidingFootprintSlider;
            daysSinceLastDiscoverySlider = __ret.daysSinceLastDiscoverySlider;
            tonnesBoughtTaggedMillsSlider = __ret.tonnesBoughtTaggedMillsSlider;
            numberOfTxnSlider = __ret.numberOfTxnSlider;
            aveP1PerMillSlider = __ret.aveP1PerMillSlider;
            sliderDaysSincePurchase = __ret.sliderDaysSincePurchase;
            sliderTonnesAtField = __ret.sliderTonnesAtField;
          }

          const handleRMSummary = () => {
            this.showRMSummary = !this.showRMSummary;
            this.$forceUpdate();
          };

          const handleShowBiocharLayerSummary = () => {
            if (
              !this.biocharSummaryData ||
              this.biocharSummaryData.applicationCount === 0 ||
              !this.emissionsData
            ) {
              this.loadBiocharSummaryData();
            }
            this.showBiocharLayerSummary = !this.showBiocharLayerSummary;
            this.$forceUpdate();
          };

          const handleShowP1Summary = () => { this.showP1Summary = !this.showP1Summary; };
          const handleReleafFactorySummary = () => { this.showRFSummary = !this.showRFSummary; };
          const handleCustomerFactorySummary = () => { this.showCFSummary = !this.showCFSummary; };
          const handleCPOTaggedReleafSummary = () => { this.showCPOTaggedReleafSummary = !this.showCPOTaggedReleafSummary; };
          const handleOilpalmClusterSummary = () => { this.showOilpalmClusterSummary = !this.showOilpalmClusterSummary; };
          const handleDeforestedOilpalmClusterSummary = () => { this.showDeforestedOilpalmClusterSummary = !this.showDeforestedOilpalmClusterSummary; };
          const handlesNgnLGASummary = () => { this.showNgnLGASummary = !this.showNgnLGASummary; };
          const handlesWardsSummary = () => { this.showWardsSummary = !this.showWardsSummary; };
          const handleClusteredMillSummary = () => { this.showClusteredMillSummary = !this.showClusteredMillSummary; };

          // ── Layer filter functions
          function releafFactoryTypeFilter(selectedIndex) {
            self.view.whenLayerView(rAssets).then((layerView) => {
              const selectOption = selectedIndex.map((o) => `'${o}'`).join(",");
              layerView.filter = { where: `type IN (${selectOption})` };
            });
          }

          function releafFactoryStatusFilter(selectedIndex) {
            self.view.whenLayerView(rAssets).then((layerView) => {
              const radioLabels = ["Active", "Inactive", "Underconstruction", "Planned (2025)", "Planned (2026)"];
              layerView.filter = { where: `status = '${radioLabels[selectedIndex]}'` };
            });
          }

          function releafFactoryTypeFilterReset(selectedIndex) {
            self.view.whenLayerView(rAssets).then((layerView) => {
              const radioLabels = ["Crushing Mill", "Refinery", "Deshelling Mill", "Kraken II", "Carbonizer", "Biochar Facility"];
              layerView.filter = { where: `type <> '${radioLabels[selectedIndex]}'` };
            });
          }

          function customerFactoryTypeFilter(selectedIndex) {
            self.view.whenLayerView(customerFactories).then((layerView) => {
              const selectOption = selectedIndex.map((o) => `'${o}'`).join(",");
              layerView.filter = { where: `type IN (${selectOption})` };
            });
          }

          function customerFactoryStatusFilter(selectedIndex) {
            self.view.whenLayerView(customerFactories).then((layerView) => {
              const radioLabels = ["Active", "Inactive", "Underconstruction"];
              layerView.filter = { where: `status = '${radioLabels[selectedIndex]}'` };
            });
          }

          function processedFactoryStatusFilter(selectedBiomassTypes, selectedSourceTypes) {
            self.view.whenLayerView(processingFactories).then((layerView) => {
              if (!selectedBiomassTypes.length || (selectedSourceTypes && !selectedSourceTypes.length)) {
                layerView.filter = { where: "1=0" };
                return;
              }
              const biomassOptions = selectedBiomassTypes.map((t) => `'${t}'`).join(",");
              let whereClause = `biomass_type IN (${biomassOptions})`;
              if (selectedSourceTypes && selectedSourceTypes.length) {
                const sourceOptions = selectedSourceTypes.map((t) => `'${t}'`).join(",");
                whereClause += ` AND source IN (${sourceOptions})`;
              }
              layerView.filter = { where: whereClause };
            });
          }

          function biocharPartnersFilter(selectedBiomassTypes) {
            self.view.whenLayerView(biocharPartnerLayer).then((layerView) => {
              if (!selectedBiomassTypes.length) {
                layerView.filter = { where: "1=0" };
                return;
              }
              const biomassOptions = selectedBiomassTypes.map((t) => `'${t}'`).join(",");
              layerView.filter = { where: `biomassType IN (${biomassOptions})` };
            });
          }

          function biocharTypeFilter(selectedTypes) {
            const biocharLayer = self.map.findLayerById("biocharApplications");
            if (!biocharLayer) return;
            self.view.whenLayerView(biocharLayer).then((layerView) => {
              if (!selectedTypes.length) {
                layerView.filter = { where: "1=0" };
                return;
              }
              const conditions = [];
              if (selectedTypes.includes("experimental"))
                conditions.push("batchIds LIKE '%EXPERIMENTAL%'");
              if (selectedTypes.includes("normal"))
                conditions.push("(batchIds NOT LIKE '%EXPERIMENTAL%' OR batchIds IS NULL)");
              layerView.filter = conditions.length
                ? { where: conditions.join(" OR ") }
                : null;
            });
          }

          function processedFarmStatusFilter(selectedStatuses) {
            self.view.whenLayerView(maizeFarm).then((layerView) => {
              layerView.filter = selectedStatuses.length
                ? { where: `farm_type IN (${selectedStatuses.map((s) => `'${s}'`).join(",")})` }
                : null;
            });
          }

          function customerFactoryTypeFilterReset(selectedIndex) {
            self.view.whenLayerView(customerFactories).then((layerView) => {
              const radioLabels = ["Crushing Mill", "Refinery", "Deshelling Mill", "Kraken II"];
              layerView.filter = { where: `type <> '${radioLabels[selectedIndex]}'` };
            });
          }

          // ── Slider filter helpers (P1AtField)
          function gtForDaySinceLastPurchase() {
            self.view.whenLayerView(P1AtField).then((layerView) => {
              sliderDaysSincePurchase.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `daysSincePurchase >= ${e.value}` };
              });
            });
          }
          gtForDaySinceLastPurchase();

          function ltForDaySinceLastPurchase() {
            self.view.whenLayerView(P1AtField).then((layerView) => {
              sliderDaysSincePurchase.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `daysSincePurchase <= ${e.value}` };
              });
            });
          }

          function gtForTonnesPurchased() {
            self.view.whenLayerView(P1AtField).then((layerView) => {
              sliderTonnesAtField.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `tonnesPurchased >= ${e.value}` };
              });
            });
          }
          gtForTonnesPurchased();

          function ltForTonnesPurchased() {
            self.view.whenLayerView(P1AtField).then((layerView) => {
              sliderTonnesAtField.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `tonnesPurchased <= ${e.value}` };
              });
            });
          }

          function agentsDropdownList(selectedIndex) {
            self.view.whenLayerView(P1AtField).then((layerView) => {
              const agentsList = self.$store.getters["auth/getAgents"];
              layerView.filter = {
                where: `UPPER(agentName) = UPPER('${agentsList[selectedIndex]}')`,
              };
            });
          }

          function pickupVehicleCheckboxes() {
            const selected = Array.from(
              document.querySelectorAll('input[name="vehicleCheckboxGroup"]:checked')
            ).map((cb) => cb.nextElementSibling.textContent);
            self.view.whenLayerView(P1AtField).then((layerView) => {
              layerView.filter = {
                where: `recommendedPickupVehicle IN ('${selected.join("', '")}')`,
              };
            });
          }

          function p1AtFieldReset() {
            self.view.whenLayerView(P1AtField).then((layerView) => {
              layerView.filter = { where: "recommendedPickupVehicle <> 1" };
            });
          }

          // ── Slider filter helpers (oilpalm cluster)
          function gtWeeklyP1Yield() {
            self.view.whenLayerView(palmoilclusterFL).then((layerView) => {
              weeklyP1YieldSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `WeeklyP1Yield >= ${e.value}` };
              });
            });
          }
          gtWeeklyP1Yield();

          function ltWeeklyP1Yield() {
            self.view.whenLayerView(palmoilclusterFL).then((layerView) => {
              weeklyP1YieldSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `WeeklyP1Yield <= ${e.value}` };
              });
            });
          }

          function oilPalmClusterReset() {
            self.view.whenLayerView(palmoilclusterFL).then((layerView) => {
              layerView.filter = { where: "ageInt <> 1" };
            });
          }

          function gtOilPalmCluster() {
            self.view.whenLayerView(palmoilclusterFL).then((layerView) => {
              oilPalmClusterSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `ageInt >= ${e.value}` };
              });
            });
          }
          gtOilPalmCluster();

          function ltOilPalmCluster() {
            self.view.whenLayerView(palmoilclusterFL).then((layerView) => {
              oilPalmClusterSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `ageInt <= ${e.value}` };
              });
            });
          }

          // ── Slider filter helpers (LGA summary)
          function gtP1LGASummary() {
            self.view.whenLayerView(lgaOilPalm).then((layerView) => {
              p1LGASummarySlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `avgPricePe >= ${e.value}` };
              });
            });
          }
          gtP1LGASummary();

          function ltP1LGASummary() {
            self.view.whenLayerView(lgaOilPalm).then((layerView) => {
              p1LGASummarySlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `avgPricePe <= ${e.value}` };
              });
            });
          }

          // ── Slider filter helpers (building footprint)
          function gtBuidingFootprint() {
            self.view.whenLayerView(buildingFP).then((layerView) => {
              buidingFootprintSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `area_in_me >= ${e.value}` };
              });
            });
          }
          gtBuidingFootprint();

          function ltBuidingFootprint() {
            self.view.whenLayerView(buildingFP).then((layerView) => {
              buidingFootprintSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `area_in_me <= ${e.value}` };
              });
            });
          }

          // ── Slider filter helpers (RFTaggedMills)
          function cpoTaggedMillsFilterReset() {
            self.view.whenLayerView(RFTaggedMills).then((layerView) => {
              layerView.filter = { where: "daysFromLastDiscovery <> 1" };
            });
          }

          function gtDaysSinceLastDiscovery() {
            self.view.whenLayerView(RFTaggedMills).then((layerView) => {
              daysSinceLastDiscoverySlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `daysFromLastDiscovery >= ${e.value}` };
              });
            });
          }
          gtDaysSinceLastDiscovery();

          function ltDaysSinceLastDiscovery() {
            self.view.whenLayerView(RFTaggedMills).then((layerView) => {
              daysSinceLastDiscoverySlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `daysFromLastDiscovery <= ${e.value}` };
              });
            });
          }

          function gtTonnesBoughtTaggedMills() {
            self.view.whenLayerView(RFTaggedMills).then((layerView) => {
              tonnesBoughtTaggedMillsSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `tonsAmount >= ${e.value}` };
              });
            });
          }
          gtTonnesBoughtTaggedMills();

          function ltTonnesBoughtTaggedMills() {
            self.view.whenLayerView(RFTaggedMills).then((layerView) => {
              tonnesBoughtTaggedMillsSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `tonsAmount <= ${e.value}` };
              });
            });
          }

          function gtNumberOfTxn() {
            self.view.whenLayerView(RFTaggedMills).then((layerView) => {
              numberOfTxnSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `noOfTransactions >= ${e.value}` };
              });
            });
          }
          gtNumberOfTxn();

          function ltNumberOfTxn() {
            self.view.whenLayerView(RFTaggedMills).then((layerView) => {
              numberOfTxnSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `noOfTransactions <= ${e.value}` };
              });
            });
          }

          // ── Slider filter helpers (RFTaggedMillsClustered)
          function gtAveP1PerMill() {
            self.view.whenLayerView(RFTaggedMillsClustered).then((layerView) => {
              aveP1PerMillSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `aveP1PMill >= ${e.value}` };
              });
            });
          }
          gtAveP1PerMill();

          function ltAveP1PerMill() {
            self.view.whenLayerView(RFTaggedMillsClustered).then((layerView) => {
              aveP1PerMillSlider.on(["thumb-change", "thumb-drag"], (e) => {
                layerView.filter = { where: `aveP1PMill <= ${e.value}` };
              });
            });
          }

          // ── Scale bar
          let scaleBar = new ScaleBar({ view: this.view });

          // ── Click handler 
          function createGraphic(point, view) {
            const graphic = new Graphic({
              geometry: point,
              symbol: { type: "simple-marker", color: "white", size: 8 },
            });
            view.graphics.add(graphic);
            return graphic;
          }

          this.view.popupEnabled = true;

          this.view.on("click", async (event) => {
            // Reverse geocode
            const serviceUrl = reverseGeocoding;
            locator.locationToAddress(serviceUrl, { location: event.mapPoint }).then(
              (response) => {
                this.$store.dispatch("serviceArea/setServiceAreaLGA", response.address);
                this.$store.dispatch("serviceArea/setServiceAreaXY", {
                  x: response.location.longitude,
                  y: response.location.latitude,
                });
              },
              (err) => console.log("Geocoding error:", err.message)
            );

            if (this.saToggle) {
              this.showModal();
              this.showServiceAreaModal = this.saToggle;
              const locationGraphic = createGraphic(event.mapPoint, this.view);
              this.serviceArea = serviceArea;
              this.serviceAreaParams = ServiceAreaParams;
              this.locationGraphic = locationGraphic;
              this.outSpatialReference = this.view.spatialReference;
              this.FeatureSet = FeatureSet;
              this.serviceAreaStartingPoint = {
                latitude: event.mapPoint.latitude,
                longitude: event.mapPoint.longitude,
              };
              return;
            }

            // Biochar Facility click handler
            const biocharProjectLayers = this.map.findLayerById("biocharProjectLayers");
            if (biocharProjectLayers && biocharProjectLayers.visible) {
              const response = await this.view.hitTest(event);
              const graphic = response.results.find(
                (r) => r.graphic.layer === this.map.findLayerById("rAssets")
              )?.graphic;

              if (graphic && graphic.attributes.type === "Biochar Facility") {
                const rAssetsLayer = this.map.findLayerById("rAssets");
                if (rAssetsLayer && graphic.attributes.__OBJECTID) {
                  const query = rAssetsLayer.createQuery();
                  query.where = `__OBJECTID = ${graphic.attributes.__OBJECTID}`;
                  query.outFields = ["id", "name", "type", "status", "processedVolume"];
                  query.returnGeometry = false;
                  try {
                    const queryResponse = await rAssetsLayer.queryFeatures(query);
                    if (queryResponse.features.length > 0) {
                      graphic.attributes = queryResponse.features[0].attributes;
                    }
                  } catch (error) {
                    console.error("Error querying rAssets for full attributes:", error);
                  }
                }
                this.currentBiocharGraphic = graphic;
                this.currentBiocharLayer = rAssetsLayer;
                this.$refs.biocharModal.showModal();
                if (this.currentBufferGraphic) {
                  this.view.graphics.remove(this.currentBufferGraphic);
                  this.currentBufferGraphic = null;
                }
                if (this.view.popup) this.view.popup.close();
              } else {
                this.isBufferActive = false;
                this.bufferCenter = null;
                this.bufferRadiusMeters = null;
              }
            }

            // OffTake click handler
            const offTakeLayers = this.map.findLayerById("offtakeLayers");
            if (offTakeLayers && offTakeLayers.visible) {
              const radiusInMeters = 50 * 1000;
              const buffer = this.geometryEngine.buffer(event.mapPoint, radiusInMeters, "meters");

              if (this.currentBufferGraphic) {
                this.view.graphics.remove(this.currentBufferGraphic);
              }
              const bufferGraphic = new this.Graphic({
                geometry: buffer,
                symbol: {
                  type: "simple-fill",
                  color: [0, 255, 0, 0.2],
                  outline: { color: [0, 128, 0], width: 1 },
                },
              });
              this.view.graphics.add(bufferGraphic);
              this.currentBufferGraphic = bufferGraphic;
              await this.queryOfftakeSuitability(buffer, event.mapPoint);
            }
          });

          this.view.ui.add(homeWidget, "top-left");
          this.view.ui.add(searchWidget, "top-left");
          this.view.ui.add(basemapGalleryExpand, "top-left");
          this.view.ui.add(layerListExpand, "top-left");
          this.view.ui.add(
            new Expand({
              view: this.view,
              content: routeDirection,
              expandIconClass: "esri-icon-north-navigation",
              expanded: false,
              expandTooltip: "Route and Directions",
            }),
            "top-left"
          );
          this.view.ui.add(basemapToggle, "bottom-right");
          this.view.ui.add(scaleBar, { position: "bottom-left" });
        }
      );
    },

    async fetchMillsAggregatedPurchases() {
      await getMillsAggregatedPurchases();
    },

    async fetchCurrentPrices() {
      await this.$store.dispatch("mills/fetchCurrentP1Prices");
    },
  },

  watch: {
    markers(newValue) {
      if (newValue) {
        console.log(newValue);
        this.loadMap();
      }
    },

    deleteAssetPromptStatus(newValue) {
      console.log(newValue);
      this.showDeleteAssetPrompt = newValue;
    },

    updatedMills(newValue) {
      this.view.graphics.removeAll();
      if (newValue) {
        this.$store.dispatch("mills/renderedFilteredMills", { mills: newValue, view: this.view });
      }
    },

    millsFilterStatus(newValue) {
      if (newValue) this.view.graphics.removeAll();
    },

    serviceAreaStartingPoint(newValue) {
      if (this.saToggle) {
        this.serviceAreaArgs = {
          divideServiceAreaValue: this.divideServiceAreaValue,
          outSpatialReference: this.outSpatialReference,
          view: this.view,
          serviceArea: this.serviceArea,
          locationGraphic: this.locationGraphic,
          serviceAreaStartingPoint: newValue,
        };
      }
    },

    showBiocharSummary(newValue) {
      if (this.view && this.view.popup) {
        this.view.popup.dockOptions = {
          position: newValue ? "bottom-left" : "auto",
          breakPoint: null,
        };
      }
    },

    isBufferActive(newValue) {
      if (this.view && this.view.popup && newValue && this.bufferCenter && this.bufferRadiusMeters) {
        const popupDistance = this.bufferRadiusMeters * 1.5;
        this.view.popup.location = {
          x: this.bufferCenter.x + popupDistance,
          y: this.bufferCenter.y,
          spatialReference: this.bufferCenter.spatialReference,
        };
      }
    },
  },
};
</script>

<style scoped>
div .sa-list p.sa {
  font-weight: bold;
  font-size: 16px;
}

.esri-view .esri-directions {
  right: 15px;
  max-height: calc(100% - 45px) !important;
}

.btn-group .button {
  background-color: #4caf50;
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  margin-left: 20px;
  margin-top: 10px;
}

.btn-group .button:hover {
  background-color: #3e8e41;
}

.date {
  margin-top: 10px;
}

.dateForm {
  width: 200px;
  padding: 10px;
  padding-bottom: 20px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 3rem 5rem rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 4px rgb(0 0 0 / 80%);
}

.dateForm .exit {
  cursor: pointer;
  text-align: right;
  margin-bottom: 5px;
}

input[type="date"] {
  border: 2px solid green;
  border-radius: 4px;
}

.setDate {
  background-color: #4caf50;
  border: solid 2px #3e8e41;
  color: white;
  padding: 8px 25px;
  text-decoration: none;
  cursor: pointer;
  margin-top: 10px;
}

.toolbar {
  position: absolute;
  top: 10px;
  right: 200px;
  z-index: 1000;
}

.toolbar button {
  padding: 8px 16px;
  background: #fff;
  color: #669933;
  border: 1px solid #669933;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}

.toolbar button:hover {
  background: #f0f0f0;
}

:deep(.toggle-container) { margin: 10px 0; }
:deep(.toggle-wrapper) { margin-bottom: 10px; }
:deep(.toggle-inner) { display: flex; align-items: center; margin-bottom: 5px; }
:deep(.toggle-radio) { margin-right: 5px; }
:deep(.toggle-label) { cursor: pointer; margin-bottom: 0px !important; }
:deep(.checkbox-group) { padding: 5px 10px; }
:deep(.checkbox-option) { display: flex; align-items: flex-start; margin: 10px 0; }
:deep(.checkboxButton) { margin-left: 5px; }
:deep(.checkbox-label) { margin-left: 5px; margin-bottom: 0px !important; }

.custom-legend-panel { padding: 10px; background: white; }
:deep(.custom-legend-title) { margin-bottom: 20px; }

.legend-item,
:deep(.legend-item) {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

:deep(.color-swatch) {
  width: 30px;
  height: 30px;
  margin-right: 8px;
  clip-path: polygon(10% 10%, 90% 5%, 85% 90%, 5% 85%);
  border: 1px solid #ccc;
  display: inline-block;
}

:deep(.range-label) { flex-grow: 1; margin-right: 8px; }
:deep(.legend-item input) { accent-color: green; }
:deep(.esri-icon-default-action) { display: none !important; }
:deep(.esri-layer-list__item-actions-menu-item--active,
       .esri-layer-list__item-actions-menu-item--active:hover) {
  background-color: transparent !important;
}
</style>